import { FC } from 'react';
import { Control, useFieldArray, UseFormSetValue, useWatch } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { buttonStyle } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import { Separator } from 'components/ui/separator';

import { CorrespondenceDirectionType, CorrespondenceForm } from 'types/correspondence';
import CorrespondenceSenderOrRecipientEntry from './CorrespondenceSenderOrRecipientEntry';

type Props = {
    control: Control<CorrespondenceForm>;
    setValue: UseFormSetValue<CorrespondenceForm>;
    validationRequired?: boolean;
};

const CorrespondencePageFormSendersOrRecipients: FC<Props> = ({ control, setValue, validationRequired = true }) => {
    const { fields, append, remove } = useFieldArray({ control, name: 'sendersOrRecipients' });
    const directionTypeCode = useWatch({ control, name: 'directionTypeCode' });

    const addButtonLabel =
        directionTypeCode === CorrespondenceDirectionType.INCOMING
            ? 'correspondence.add-sender'
            : 'correspondence.add-recipient';

    const canRemove = fields.length > 1;

    return (
        <>
            {fields.map((field, index) => (
                <div key={field.id}>
                    {index > 0 && <Separator className="my-4" />}
                    <CorrespondenceSenderOrRecipientEntry
                        control={control}
                        setValue={setValue}
                        index={index}
                        onRemove={canRemove ? () => remove(index) : undefined}
                        validationRequired={validationRequired}
                    />
                </div>
            ))}
            <div>
                <Button
                    {...buttonStyle({ variant: 'outlined', color: 'secondary' })}
                    onClick={() => append({ partyPerson: null, partyCompany: null, correspondencePartyAddress: null })}
                >
                    <FormattedMessage id={addButtonLabel} />
                </Button>
            </div>
        </>
    );
};

export default CorrespondencePageFormSendersOrRecipients;
